import { useCallback, useRef } from 'react'

export const useCachedResults = (cacheActiveMinutes = 2) => {
    const cachedResult = useRef({});
    const setCachedResult = useCallback((key, data) => {
        const cachedTime = Date.now() + (cacheActiveMinutes) * (60) * 1000;
        cachedResult.current[key] = {
            time: cachedTime,
            result: data
        }
    }, [cacheActiveMinutes])
    const getCachedResult = useCallback((key) => {
        const storedResult = cachedResult.current[key];
        if (storedResult) {
            const isCacheActive = storedResult.time > Date.now();
            if (isCacheActive) {
                return storedResult.result;
            }
            else {
                delete cachedResult.current[key];
                return null;
            }
        }
        return null;
    }, []);

    return {
        setCachedResult,
        getCachedResult
    }

}   
